/** Failed retire/reassign request, carrying the backend message and status. */
export class CustomerDeviceActionError extends Error {
  constructor(
    message: string,
    readonly statusCode: number
  ) {
    super(message);
    this.name = "CustomerDeviceActionError";
  }
}
